const RATING_OPTIONS = [
  { value: '', label: 'Select rating...', color: '' },
  { value: '1', label: '1 - No repair needed', color: 'bg-green-100 text-green-800 border-green-300' },
  { value: '2', label: '2 - Repairs needed (not urgent)', color: 'bg-amber-100 text-amber-800 border-amber-300' },
  { value: '3', label: '3 - Urgent repairs/investigation needed', color: 'bg-red-100 text-red-800 border-red-300' },
  { value: 'NI', label: 'NI - Not inspected', color: 'bg-gray-100 text-gray-800 border-gray-300' }
]

// Helper to get rating color classes
const getRatingColorClass = (rating) => {
  const option = RATING_OPTIONS.find(opt => opt.value === rating)
  return option?.color || ''
}

export function ElementRating({ code, label, rating, comment, onChange }) {
  return (
    <div className="border border-slate-200 rounded-lg p-4 space-y-3">
      {/* Element Header */}
      <div className="flex items-center justify-between">
        <h4 className="font-semibold text-slate-900">{code}: {label}</h4>
        <div className="w-64">
          <select
            name={`${code}-rating`}
            value={rating || ''}
            onChange={(e) => onChange(e.target.value, comment)}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${getRatingColorClass(rating)}`}
          >
            {RATING_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Comment Field */}
      <div>
        <textarea
          name={`${code}-comment`}
          value={comment || ''}
          onChange={(e) => onChange(rating, e.target.value)}
          placeholder={`Describe the condition of ${label.toLowerCase()}...`}
          rows={4}
          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm"
        />
      </div>

      {/* Rating Legend (shown if rating selected) */}
      {rating && (
        <div className="text-xs text-slate-500 bg-slate-50 p-2 rounded">
          <strong>Rating {rating}:</strong>{' '}
          {rating === '1' && 'No repair currently needed. Normal maintenance required.'}
          {rating === '2' && 'Defects that need repairing or replacing but are not serious or urgent.'}
          {rating === '3' && 'Defects that are serious and/or need urgent repair or investigation.'}
          {rating === 'NI' && 'Not inspected (explain reason in comment).'}
        </div>
      )}
    </div>
  )
}

export default ElementRating
